import React from 'react';

import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function Approach () {
      const imgStyle = {
        maxWidth: '100%',
        maxWeight: '100%',
        objectFit: 'contain'
    };
    return (
        <Container maxWidth="md" sx={{margin: 4}} >
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
          <Stack>
              <Typography variant="h6" component="h2" sx={{fontWeight: 600, textAlign: { xs: 'left', md: 'right' } }}>
               APPROACH
              </Typography>
          </Stack>
          <Stack>
              <Typography variant="body1" component="span" sx={{'textAlign': 'left' }}>
              We propose Shape2Animal, a pipeline that transforms natural object images into animal forms while preserving the original silhouette and background. Our approach extracts object silhouettes using Grounding DINO for language-based localization and SAM for precise mask generation. The extracted silhouette is then interpreted by the Gemini 2.5 vision-language model to generate appropriate animal descriptors. These descriptors guide a controlled image synthesis pipeline leveraging SDXL inpainting with ControlNet-depth integration (α ∈ {"{0.999; 1.0}"}) to generate animal forms that conform to the original silhouette. Finally, we blend the generated animal with the original image at 50% opacity within the mask region to ensure natural integration with the preserved background.
              </Typography>
          </Stack>
        </Stack>
        <Box style={{paddingTop: 16}}>
            <img src='/overview.jpg' style={imgStyle}/>
          </Box>
        </Container>
    );
};
export default Approach;